import React from "react";
import { Accordion, Col, ListGroup, Row } from "react-bootstrap";
import HeroSection from "../../Common/HeroSection/HeroSection";

const Blog = () => {
  return (
    <>
      <HeroSection name={"Blog"}></HeroSection>
      <div className="container my-5 ">
        <Row>
          <Col lg="6" md="8" sm="12" className="m-auto">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  {" "}
                  Difference between authorization and authentication
                </Accordion.Header>
                <Accordion.Body>
                  Both the authentication and authentication unit used in
                  relation to information security allows for security in the
                  default data system. Each area unit is one of the most
                  important Internet-related topics as key features of its
                  service infrastructure.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  Why are you using firebase? What other options do you have to
                  implement authentication?
                </Accordion.Header>
                <Accordion.Body>
                  <ListGroup variant="flush">
                    <ListGroup.Item>Secured By Google</ListGroup.Item>
                    <ListGroup.Item>Easy to use and maintain</ListGroup.Item>
                    <ListGroup.Item>
                      Hosing and Support Realtime Database
                    </ListGroup.Item>
                    <ListGroup.Item>It's Safe and It's free!</ListGroup.Item>
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  {" "}
                  What other services does firebase provide other than
                  authentication
                </Accordion.Header>

                <Accordion.Body>
                  <ListGroup>
                    <ListGroup.Item variant="primary">
                      Cloud Firestore
                    </ListGroup.Item>
                    <ListGroup.Item variant="secondary">Hosting</ListGroup.Item>
                    <ListGroup.Item variant="success">
                      Cloud Functions
                    </ListGroup.Item>
                    <ListGroup.Item variant="danger">
                      Google Analytics
                    </ListGroup.Item>
                    <ListGroup.Item variant="warning">Warning</ListGroup.Item>
                    <ListGroup.Item variant="info">
                      Dynamic Links
                    </ListGroup.Item>
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Blog;
